import { Button, Col, Form, Modal, Row } from "antd";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import FormAction from "../../../../components/common/FormAction";
import Notes from "../../../../components/common/Notes";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RecurringDetails from "./components/RecurringDetails";
import RecurringInformation from "./components/RecurringInformation";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import "./RecurringWorkOrderDetails.css";
import { collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";

import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import toast from "react-hot-toast";

function RecurringWorkOrderDetails() {
  const [edit, setEdit] = useState(false);
  const [recWorkOrder, setRecWorkOrder] = useState({});
  const [notes, setNotes] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [accounts, setAccounts] = useState([
    {
      id: uuidv4(),
      account: "",
      statmentDescription: "",
      amount: "",
    },
  ]);
  const [options, setOptions] = useState([
    { value: "January", check: false },
    { value: "February", check: false },
    { value: "March", check: false },
    { value: "April", check: false },
    { value: "May", check: false },
    { value: "June", check: false },
    { value: "July", check: false },
    { value: "August", check: false },
    { value: "September", check: false },
    { value: "October", check: false },
    { value: "November", check: false },
    { value: "December", check: false },
  ]);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const { id } = useParams();
  console.log(id);

  const fetchServiceRequests = async () => {
    const serviceRequestRef = collection(
      db,
      "companies",
      companyName,
      "recurringWorkOrders"
    );
    const propertiesRef = collection(
      db,
      "companies",
      companyName,
      "properties"
    );
    const vendorRef = collection(db, "companies", companyName, "vendors");
    const snapShotData = await getDocs(propertiesRef);
    const fetchedProperties = snapShotData.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const snapShotDataVendor = await getDocs(vendorRef);
    const fetchedVendors = snapShotDataVendor.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    try {
      const snapShot = await getDocs(serviceRequestRef);
      const fetchedData = snapShot.docs.map((doc) => {
        const workOrderId = doc.id;
        const workOrderData = doc.data();

        const matchingProperty = fetchedProperties.find(
          (property) =>
            property.id === workOrderData.details.propertyInfo.propertyId
        );

        const matchingVendor = fetchedVendors.find(
          (vendor) => vendor.id === workOrderData.details.vendorInfo.vendorId
        );

        if (matchingProperty || matchingVendor) {
          const propertyName = `${matchingProperty?.propertyNameAddress.propertyName}`;
          const maintenanceLimit = `${matchingProperty?.maintenanceInformation.maintenanceLimit}`;
          const maintenanceNotes = `${matchingProperty?.maintenanceInformation.maintenanceNotes}`;
          const vendorName = `${matchingVendor?.vendorInfo.firstName} ${matchingVendor?.vendorInfo.lastName}`;
          return {
            id: workOrderId,
            key: workOrderId,
            vendor: vendorName,
            ...workOrderData,
            maintenanceLimit,
            maintenanceNotes,
            property: propertyName,
          };
        }
      });

      const newData = fetchedData.find((item) => item.id === id);
      setAccounts(
        newData.details.billingInfo.length > 0
          ? newData.details.billingInfo
          : [
              {
                id: uuidv4(),
                account: "",
                statmentDescription: "",
                amount: "",
              },
            ]
      );
      setRecWorkOrder(newData);

      console.log("fetchedDatafetchedData", newData);
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchServiceRequests();
  }, [companyName, isCompanyNameFetched]);

  const onCancel = () => {
    setEdit(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShowModalPost, setIsShowModalPost] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setIsShowModalPost(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsShowModalPost(false);
  };
  const showPostWorkOrderModal = () => {
    setIsShowModalPost(true);
  };

  const RecurringWorkOrderDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "New Service Request",
        "1",
        "",
        "",
        "/maintenance/work-orders/service-requests/new"
      ),
      RightBarMethod(
        "New Recurring Work Order",
        "2",
        "",
        "",
        "/maintenance/recurring-work-orders/new"
      ),
      RightBarMethod(
        <a onClick={showModal}>Delete Recurring Work Order</a>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <a onClick={showPostWorkOrderModal}>Post Work Order Now</a>,
        "4",
        "",
        "",
        ""
      ),
    ]),
    RightBarMethod(
      "REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Work Order", "5", "", "", ""),
        RightBarMethod("Association Work Order", "6", "", "", ""),
      ]
    ),
  ];

  console.log("WorkOrderDetails*******", recWorkOrder);

  const initialValues = {
    startDate: recWorkOrder?.recurranceInformation?.startDate
      ? dayjs(recWorkOrder?.recurranceInformation?.startDate, "YYYY-MM-DD")
      : "",
    endDate: recWorkOrder?.recurranceInformation?.endDate
      ? dayjs(recWorkOrder?.recurranceInformation?.endDate, "YYYY-MM-DD")
      : "",
    repeats: recWorkOrder?.recurranceInformation?.repeats
      ? recWorkOrder?.recurranceInformation?.repeats
      : "",
    postDay: recWorkOrder?.recurranceInformation?.postDay
      ? recWorkOrder?.recurranceInformation?.postDay
      : "",
    selectMonth: recWorkOrder?.recurranceInformation?.selectedMonths
      ? recWorkOrder?.recurranceInformation?.selectedMonths
      : "",
    properties: recWorkOrder?.details?.propertyInfo?.propertyId,
    unit: recWorkOrder?.details?.propertyInfo?.unit,
    creationStyle: recWorkOrder?.details?.propertyInfo?.creationStyle,
    description: recWorkOrder?.details?.workOrderInfo?.description,
    vendorInstructions:
      recWorkOrder?.details?.workOrderInfo?.vendorInstructions,
    vendor: recWorkOrder?.details?.vendorInfo?.vendorId,
    assignTo: recWorkOrder?.details?.vendorInfo?.assignTo,
  };

  const onFinish = (values) => {

    const filterOptions = options.filter((option) => option.check);
    const updatedValues = {
      recurranceInformation: {
        startDate: values.startDate
          ? values.startDate.format("YYYY-MM-DD")
          : "" || "",
        endDate: values.endDate
          ? values.endDate.format("YYYY-MM-DD")
          : "" || "",
        repeats: values.repeat || "",
        postDay: values.postDay || "",
        selectedMonths: filterOptions || null,
      },

      "details.propertyInfo.propertyId": values.properties || "",
      "details.propertyInfo.unit": values.unit || "",
      "details.propertyInfo.creationStyle": values.creationStyle || "",
      "details.workOrderInfo.description": values.description || "",
      "details.workOrderInfo.vendorInstructions":
        values.vendorInstructions || "",
      "details.vendorInfo.vendorId": values.vendor || "",
      "details.vendorInfo.assignTo": values.assignTo || "",
      "details.billingInfo": accounts.length > 0 ? accounts : [],
    };

    const docRef = doc(db, "companies", companyName, "recurringWorkOrders", id);

    try{
      updateDoc(docRef, updatedValues);
      console.log("successflly updated");
      toast.success("Updated");
    }catch(err){
      console.log("error found");
    }
  };

  const onFinishFailed = (err) => {
    console.log("Error while form submission",err);
  }

  return (
    <>
      <div className="rec-work-order">
        <div className="rec-heading-container">
          <PageHeading heading="Recurring Work Order" />
          {!edit ? (
            <button className="edit-btn" onClick={() => setEdit(true)}>
              Edit
            </button>
          ) : null}
        </div>
        {recWorkOrder ? (
          <Row gutter={[0, 24]}>
            {edit ? (
              <Form
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                initialValues={initialValues}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Col span={24}>
                  <RecurringInformation
                    edit={edit}
                    data={recWorkOrder?.recurranceInformation}
                    monthOptions={options}
                    setOptions={setOptions}
                  />
                </Col>
                <Col span={24}>
                  <RecurringDetails
                    edit={edit}
                    data={recWorkOrder?.details}
                    accounts={accounts}
                    setAccounts={setAccounts}
                    companyName={companyName}
                  />
                </Col>
                <Col span={24}>
                  <FormAction submit="submit" cancel={onCancel} />
                </Col>
              </Form>
            ) : (
              <>
                <Col span={24}>
                  <RecurringInformation
                    edit={edit}
                    data={recWorkOrder?.recurranceInformation}
                    monthOptions={options}
                    setOptions={setOptions}
                  />
                </Col>
                <Col span={24}>
                  {recWorkOrder ? (
                    <RecurringDetails edit={edit} data={recWorkOrder} />
                  ) : null}
                </Col>
              </>
            )}
            <Col span={24}>
              {companyName ? (
                <Notes
                  notesForCollection="recurringWorkOrders"
                  notesForCollectionId={id}
                  companyName={companyName}
                  notes={notes}
                  setNotes={setNotes}
                />
              ) : null}
            </Col>
            <Col span={24}>
              {companyName ? (
                <AttachmentsUpload
                  id={id}
                  data={recWorkOrder?.attachments}
                  companyName={companyName}
                  collection="recurringWorkOrders"
                />
              ) : null}
            </Col>
          </Row>
        ) : null}
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RecurringWorkOrderDetailsRightBar} />
      </div>

      <Modal
        title="Please Confirm"
        centered
        open={isModalOpen}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <p>Do you want to delete this recurring bill?</p>
      </Modal>

      <Modal
        title="Please Confirm"
        centered
        open={isShowModalPost}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Ok
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <p>
          Are you sure you want to create work orders from this recurring work
          order now?
        </p>
      </Modal>
    </>
  );
}

export default RecurringWorkOrderDetails;
